import { CbhIcon, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

import { LoadingIconButton } from "../../components/LoadingIconButton";

interface AddRoleRowProps {
  qualificationName: string;
  requiresLicense: boolean;
  isAdded: boolean;
  isAdding: boolean;
  onAdd: () => Promise<void>;
}

export function AddRoleRow(props: AddRoleRowProps) {
  const { qualificationName, requiresLicense, isAdded, isAdding, onAdd } = props;

  return (
    <Stack
      sx={{
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 4,
      }}
    >
      <Box sx={{ paddingLeft: 3 }}>
        <Text variant="h6">{qualificationName}</Text>

        {!requiresLicense && (
          <Text
            variant="caption"
            sx={(theme) => ({ paddingTop: 1, color: theme.palette.intent?.success.text })}
          >
            No license required
          </Text>
        )}
      </Box>

      {isAdded ? (
        <Box
          sx={(theme) => ({
            width: theme.size?.iconButton.small.size,
            height: theme.size?.iconButton.small.size,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          })}
        >
          <CbhIcon
            type="checkmark"
            size="medium"
            sx={(theme) => ({ color: theme.palette.intent?.success.icon })}
          />
        </Box>
      ) : (
        <LoadingIconButton
          isLoading={isAdding}
          variant="outlined"
          iconType="plus"
          size="small"
          aria-label={`Add ${qualificationName} role`}
          onClick={onAdd}
        />
      )}
    </Stack>
  );
}
